var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"competitors-contrast-container"},[_c('div',[_c('MyPrincipal',{ref:"MyPrincipal",attrs:{"infoData":_vm.infoData}})],1),_c('div',[_c('EnemyPrincipal',{ref:"EnemyPrincipal",attrs:{"infoData":_vm.otherInfoData,"enemyData":_vm.enemyData},on:{"changePrincipal":_vm.changePrincipal}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }